/** @type {import("pliny/config").PlinyConfig } */
const siteMetadata = {
  title: 'AlliSports News Blog',
  author: 'AlliSports Media Hub',
  headerTitle: 'AlliSports News',
  description: `Independent Nigerian and global sports news, match coverage, interviews, and data-led analysis across football, athletics, and more.`,
  language: 'en-us',
  theme: 'dark', // system, dark or light
  siteUrl: 'https://sports.allimediahub.com',
  siteRepo: 'https://github.com/Alli-Media-Group/Alli-news-blog',
  siteLogo: `${process.env.BASE_PATH || ''}/static/images/color_logo.png`,
  socialBanner: `${process.env.BASE_PATH || ''}/static/images/twitter-card.png`,
  // mastodon: 'https://mastodon.social/@mastodonuser',
  email: 'allinewsnigeria@gmail.com',
  // github: 'https://github.com/Alli-Media-Group',
  x: 'https://x.com/AllinewsNigeria',
  // twitter: 'https://twitter.com/AllinewsNigeria',
  facebook: 'https://www.facebook.com/share/1FX3DbKgbw/',
  youtube: 'https://www.youtube.com/@AlliNewsStudioNetwork',
  linkedin: 'https://www.linkedin.com/company/allisport-media-hub/',
  // threads: 'https://www.threads.net',
  instagram: 'https://www.instagram.com/allinewsnigeria/',
  tiktok: 'https://www.tiktok.com/@allinewsnigeria3/',
  // medium: 'https://medium.com',
  // bluesky: 'https://bsky.app/',
  locale: 'en-US',
  // set to true if you want a navbar fixed to the top
  stickyNav: false,
  analytics: {
    // If you want to use an analytics provider you have to add it to the
    // content security policy in the `next.config.js` file.
    // supports Plausible, Simple Analytics, Umami, Posthog or Google Analytics.
    // umamiAnalytics: {
    // We use an env variable for this site to avoid other users cloning our analytics ID
    // umamiWebsiteId: process.env.NEXT_UMAMI_ID, // e.g. 123e4567-e89b-12d3-a456-426614174000
    // You may also need to overwrite the script if you're storing data in the US - ex:
    // src: 'https://us.umami.is/script.js'
    // Remember to add 'us.umami.is' in `next.config.js` as a permitted domain for the CSP
    // },
    // plausibleAnalytics: {
    //   plausibleDataDomain: '', // e.g. tailwind-nextjs-starter-blog.vercel.app
    // If you are hosting your own Plausible.
    //   src: '', // e.g. https://plausible.my-domain.com/js/script.js
    // },
    // simpleAnalytics: {},
    // posthogAnalytics: {
    //   posthogProjectApiKey: '', // e.g. 123e4567-e89b-12d3-a456-426614174000
    // },
    googleAnalytics: {
      googleAnalyticsId: process.env.NEXT_GOOGLE_ANALYTICS_KEY || 'G-VSG75PMVK7', // e.g. G-XXXXXXX
    },
    clarityAnalytics: {
      ClarityWebsiteId: 'qje00r28oq',
    },
  },
  newsletter: {
    // supports mailchimp, buttondown, convertkit, klaviyo, revue, emailoctopus, beehive
    // Please add your .env file and modify it according to your selection
    provider: 'convertkit',
  },
  comments: {
    // If you want to use an analytics provider you have to add it to the
    // content security policy in the `next.config.js` file.
    // Select a provider and use the environment variables associated to it
    // https://vercel.com/docs/environment-variables
    provider: 'disqus', // supported providers: giscus, utterances, disqus
    disqusConfig: {
      shortname: process.env.NEXT_PUBLIC_DISQUS_SHORTNAME,
    },
    // giscusConfig: {
    //   // Visit the link below, and follow the steps in the 'configuration' section
    //   // https://giscus.app/
    //   repo: process.env.NEXT_PUBLIC_GISCUS_REPO,
    //   repositoryId: process.env.NEXT_PUBLIC_GISCUS_REPOSITORY_ID,
    //   category: process.env.NEXT_PUBLIC_GISCUS_CATEGORY,
    //   categoryId: process.env.NEXT_PUBLIC_GISCUS_CATEGORY_ID,
    //   mapping: 'pathname', // supported options: pathname, url, title
    //   reactions: '1', // Emoji reactions: 1 = enable / 0 = disable
    //   // Send discussion metadata periodically to the parent window: 1 = enable / 0 = disable
    //   metadata: '0',
    //   // theme example: light, dark, dark_dimmed, dark_high_contrast
    //   // transparent_dark, preferred_color_scheme, custom
    //   theme: 'dark',
    //   // theme when dark mode
    //   darkTheme: 'transparent_dark',
    //   // If the theme option above is set to 'custom`
    //   // please provide a link below to your custom theme css file.
    //   // example: https://giscus.app/themes/custom_example.css
    //   themeURL: '',
    //   // This corresponds to the `data-lang="en"` in giscus's configurations
    //   lang: 'en',
    // },
  },
  search: {
    provider: 'kbar', // kbar or algolia
    kbarConfig: {
      searchDocumentsPath: `${process.env.BASE_PATH || ''}/search.json`, // path to load documents to search
    },
    // provider: 'algolia',
    // algoliaConfig: {
    //   // The application ID provided by Algolia
    //   appId: 'R2IYF7ETH7',
    //   // Public API key: it is safe to commit it
    //   apiKey: '599cec31baffa4868cae4e79f180729b',
    //   indexName: 'docsearch',
    // },
  },
  studio: {
    join_team_author_form: '',
  },
  notification: {
    onesignalAppId: process.env.NEXT_PUBLIC_ONESIGNAL_APP_ID,
  },
}

module.exports = siteMetadata
